import React, { useState , useCallback, useEffect} from "react";
import FilterInput from "components/Form/filterInput"
import { Tag } from 'antd';

import {  useSelector } from 'react-redux';
import { toTitleCase } from "utils/common";
import { useSearchParams } from 'react-router-dom';
import {format} from "date-fns"
import {primaryColor} from "utils/constants";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons';

import { Button } from "components/Button";


const ResumeListFilter = ({handleFilterDrawer, filters, handleInputChange, searchPlaceholder, handleFilterChange, loading}) => {
  const {
    department, departmentLoading,
    reportTo, reportToLoading,
    nationality, nationalityLoading,
    position, positionLoading,
    division, divisionLoading,
    
} = useSelector((state) => state.common);

const [searchParams, setSearchParams] = useSearchParams();

  const [appliedFilters, setAppliedFilters] = useState([])


  const setInputValue = useCallback((key) => {

   console.log(filters, "---filters in setinputvalueeeeeee")
    if(filters.length){
      let selectedValue = [...filters].find(item=> item.key === key)
      return selectedValue?.value
    }else{
      return ""
    }
  
  }, [filters]);

    useEffect(()=>{
      console.log('useEffeeect')
    if(!departmentLoading && !reportToLoading && !nationalityLoading && !positionLoading && !divisionLoading ){

      console.log(filters, "LLLs")

      let _appliedFilters = [...filters].map(item=>{
        let label = ""
        let value = ""
        switch(item.key){
          case "employment_date_after":
            let date = toTitleCase(searchParams.get("employment_date_after") || "")
            let date_formatted = ""
            if(date){
              date_formatted = format(searchParams.get("employment_date_after"), "yyyy-MM-dd")
            }
            value = date_formatted
            label = "Joined after"
            break;
          case "employment_date_before":
            let date_before = toTitleCase(searchParams.get("employment_date_before") || "")
            let date_formatted_before = ""
            if(date_before){
              date_formatted_before = format(searchParams.get("employment_date_before"), "yyyy-MM-dd")
            }
            value = date_formatted_before
            label = "Joined before"
            break;
            case "search":
              value = toTitleCase(searchParams.get("search") || "")
              label = "Search term"
              break;
          case "report_to":
            let selectedReportTo = [...reportTo].find(item=>item.user_id ==  searchParams.get("report_to") || "")
            value = selectedReportTo?.first_name
            label = "Report to"
            break;
          case "gender":
            // label = "Gender"
            value = toTitleCase(searchParams.get("gender") || "")
            break;
          case "department":
            let selectedDepartment = [...department].find(item=>item.id == searchParams.get("department") || "")
            // label = "Department"
            value = selectedDepartment?.name
            break;
          case "position":
            let selectedPosition = [...position].find(item=>item.id == searchParams.get("position") || "")
            // label = "Position"
            value = selectedPosition?.name
            break;
          case "nationality":
            let selectedNationality = [...nationality].find(item=>item.id == searchParams.get("nationality") || "")
            // label = "Nationality"
            value = selectedNationality?.name
            break;
            
          case "division":
            let selectedDivision = [...division].find(item=>item.id == searchParams.get("division") || "")
            // label = "Division"
            value = selectedDivision?.name
            break;
          case "marital_status":
            // label = "Marital Status"
            value = toTitleCase(searchParams.get("marital_status") || "")
            break;
          default:
            label = ""
            value = ""
        }
        return {
          ...item,
          value,
          label
        }
      })
      setAppliedFilters(_appliedFilters.filter(item=> item.value && item.key != "search"))

  
    }

 
  },[
    department,
    reportTo,
    nationality,
    position,
    division,
    searchParams
  ])


  const handleClose = (e, item) => {
    console.log(item, "llll")
    e.preventDefault();
    if(item.key == "search" || item.key == "employment_date_after" || item.key == "employment_date_before"){
      handleInputChange("", item.key, true)
    }else{
      handleFilterChange("", item.key, true)
    }
  }
  return (
    <div className="mb-4">
      <div className="row align-items-center g-3">
        <div className="col-lg-9 col-md-12">
          <div className="row g-3">
            <div className='col-sm-12 col-lg-4'>
              <FilterInput  
                defaultValue={setInputValue("search")} 
                onChange={e=>{handleInputChange(e.target.value, "search", true)}} 
                id="search"
                label={searchPlaceholder}
              />
            </div>
            <div className='col-sm-12 col-lg-8 d-flex flex-wrap align-items-center gap-2'>
              {appliedFilters.map((item, index) => (
                <Tag 
                  key={index}
                  icon={loading && <i className="fas fa-spinner fa-spin me-1" aria-hidden="true"></i>} 
                  className="mb-0" 
                  color="#D3001A"
                  style={{ 
                    borderRadius: "6px",
                    padding: "4px 12px",
                    fontSize: "13px",
                    fontWeight: "500",
                    border: "none"
                  }}
                  closeIcon={<i className="fa fa-times" style={{ fontSize: "11px" }}></i>} 
                  onClose={e=>handleClose(e, item)}
                >
                  {item?.label}
                  {item.label && " : "}
                  {item?.value}
                </Tag>
              ))}
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-12 d-flex justify-content-end gap-2" style={{ paddingRight: 0 }}>
          <div className="view-icons position-relative">
            <Button
              onClick={handleFilterDrawer}
              icon="las la-filter"
              className="list-view btn btn-link position-relative"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResumeListFilter;
